// src/InputField.js
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  styled,
  TextareaAutosize,
  TextField,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import styles from "./ChatBotComponent.module.css";
import FileAttach from "./../../Assets/Images/fileattachment.png";
import MessageSent from "./../../Assets/Images/messagesent.png";
import eventEmitter from "./EventEmitter";
import { restrictedUsers, TOPLINE_AUTO_SUGGESTIONS_WHAT, TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT } from "../../Common/Constants";
import moreoptions from "../../Assets/Images/moreoptions.png";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { callLogEvent, getFileSizeInMB, Item } from "../../Common/Util";
import SpeechToText from "./SpeechToText";
import { uploadFile } from "../../Services/chat-bot-service";
import tipsIcon from "../../Assets/Images/tips.png";
import { title } from "process";


const useStyles = makeStyles({
  root: {},
  autoTextfield: {
    border: "none",
    boxShadow: "none !important",
    "& input": {
      position: "relative",
    }
  },
  menuStyles: {
    "& .MuiMenuItem-root": {
      margin: "5px",
      border: "1px solid rgba(0, 0, 0, 0.12)",
      borderRadius: "5px",
      fontSize: "10px",
    },
  },
  moreOptions: {
    display: "inline-block",
  },
});

const InputField = ({
  onSend,
  onEnter,
  isIdeal,
  inputValue,
  setInputValue,
  hidden = false,
  handleDocId,
  pageTitle
}: any) => {

  const [options, setOptions] = useState<any>([]);
  const autocompleteRef = useRef<any>(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [placeholderMessage, setPlaceholderMessage] = useState("Type your question...");


  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    callLogEvent("CLICKED_ON_NEW_DAILOG_CATBOX_MORE_OPTIONS_BUTTON", "clicked on more options button for chatbox");
    // handlePlaceHolderMessage();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!isIdeal) {
      setPlaceholderMessage("Loading search results");
    } else {
      setPlaceholderMessage("Type your question...");
    }
  }, [isIdeal])

  useEffect(() => {
    const recieveMessage = (inputMsg: any) => {
      setInputValue(inputMsg?.message);
      if (autocompleteRef.current) {
        autocompleteRef.current.focus();
      }
    };
    eventEmitter.on("publishMessageToInput", recieveMessage);
    return () => {
      eventEmitter.off("publishMessageToInput", recieveMessage);
    };
  });

  const handleSend = () => {
    if (inputValue.trim() && isIdeal) {
      onSend(inputValue);
    }
    setInputValue("");
  };

  const handleOnKeyDown = (event: any) => {
    if (
      isIdeal &&
      ((!event.shiftKey && event.key === "Enter") ||
        (event.ctrlKey && event.key === "Enter")) &&
      inputValue
    ) {
      event.preventDefault();
      onEnter(inputValue);
      setInputValue("");
    }
  };

  const handleValueChange = (newValue: any) => {
    if (isIdeal) {
      setInputValue(newValue);

      if (newValue) {
        let matchCriteria = (pageTitle=="UAE MT")?TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT:TOPLINE_AUTO_SUGGESTIONS_WHAT;
        const matchFound = matchCriteria?.filter((item: any) =>
          item.toLowerCase().startsWith(newValue.toLowerCase())
        );
        setOptions(matchFound);
      } else {
        setOptions([]);
      }
    }
  };

  const onSuggestionClick = (val: any) => {
    callLogEvent("CLICKED_ON_NEW_DAILOG_CHATBOX_MORE_OPTIONS_" + val.toUpperCase().trim().replaceAll(' ', '_') + "_BUTTON", "clicked on more options button for chatbox");
    setInputValue(val);
    if (autocompleteRef.current) {
      autocompleteRef.current.focus();
    }
  };

  const handleSpeechToText = (data: any) => {
    setInputValue(data.transcript);
    if (data.transcript && data.status && data.status === "completed") {
      handleSend();
    }
  }

  const handleFileChange = async (event: any) => {
    const newFile: File = event.target.files[0];
    if (newFile) {
      setIsLoading(true);
      if (getFileSizeInMB(newFile) <= 10) {
        const bodyFormData = new FormData();
        bodyFormData.append('file', newFile!);

        const result = await uploadFile(bodyFormData);

        if (result.docfile_id) {
          if (result.docfile_id === "failure") {
            console.log("upload file failed");
            handleDocId("");
            setShowError(true);
            callLogEvent("NEW_DIALOG_FILE_UPLOAD_ACTION_FAILED", "File uploading failed");
            setTimeout(() => {
              setShowError(false);
            }, 2000);
          } else {
            handleDocId(result.docfile_id);
            setShowSuccess(true);
            setTimeout(() => {
              setShowSuccess(false);
            }, 2000);
            console.log("File Uploaded successfully::", result.docfile_id);
            callLogEvent("NEW_DIALOG_FILE_UPLOAD_ACTION_COMPLETE", "Attached file to the chat box window with file id: " + result.docfile_id);
          }
        } else {
          console.log("Something went wrong please try again after sometime");
          handleDocId("");
          setShowError(true);
          callLogEvent("NEW_DIALOG_FILE_UPLOAD_ACTION_FAILED", "File uploading failed");
          setTimeout(() => {
            setShowError(false);
          }, 2000);
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
        console.log("File size exceeded");
        handleDocId("");
        setShowError(true);
        callLogEvent("NEW_DIALOG_FILE_UPLOAD_ACTION_FAILED", "File uploading failed due to high file size");
        setTimeout(() => {
          setShowError(false);
        }, 2000);
      }
    }
  };
  const moreOptionsComponent = () => {
    return <Grid item className={classes.moreOptions}>
      <Item className={classes.autoTextfield}>
        <Button
          id="demo-positioned-button"
          aria-controls={open ? "demo-positioned-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          className={styles.moreOptions}
          // disabled={!isIdeal}
          disabled={restrictedUsers.includes(sessionStorage.getItem("emailid")?.toLowerCase()!) ? restrictedUsers.includes(sessionStorage.getItem("emailid")?.toLowerCase()!) : !isIdeal}
        >
          <img
            src={moreoptions}
            style={{ height: "60px" }}
            alt="more options"
          />{" "}
        </Button>
        <Menu
          id="demo-positioned-menu"
          aria-labelledby="demo-positioned-button"
          anchorEl={anchorEl}
          open={open}

          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          className={classes.menuStyles}
        >
          <MenuItem
            onClick={() => {
              onSuggestionClick("Frequently Asked Questions");
              handleClose();
            }}
          >
            FAQs
          </MenuItem>
          <MenuItem
            onClick={() => {
              onSuggestionClick("What");
              handleClose();
            }}
          >
            What
          </MenuItem>
          <MenuItem
            onClick={() => {
              onSuggestionClick("Generate Visuals");
              handleClose();
            }}
          >
            Generate Visuals
          </MenuItem>
          <MenuItem
            onClick={() => {
              onSuggestionClick("More");
              handleClose();
            }}
          >
            More
          </MenuItem>
        </Menu>
      </Item>
    </Grid>
  }
  const handleAttachmentClick = () => {
    callLogEvent("CLICKED_ON_NEW_DAILOG_ATTACHMENT_BUTTON", "clicked on attachment button to upload file");
  }

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile2 = false;

  const NoMaxWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: "none",
    },
  });

  return (<>

    {hidden && <div style={{ width: "100%" }} className={classes.root}>

      <span className={styles.moreOptionsMobile}>
        <Grid
          container
          spacing={2}
          style={{
            background: "#fff",
            bottom: "13px",
            position: "relative",
            margin: "0 auto",
            display: "block",
            width: "70%",
          }}
        >
          {moreOptionsComponent()}
        </Grid>
      </span>
      <div
        className={styles.inputFieldContainer}
      >

        <Grid
          container
          direction="column"
          spacing={1}
          className={styles.inputFieldGrid}
        >
          <Grid item className={styles.autoCompleteItem}>
            <Item style={{border:"none", maxWidth:"110vh", marginLeft:"2px", boxShadow:"none", marginBottom:"-32px"}} hidden={isMobile}>
              <div style={{textAlign:"left", marginTop:"-0.5vh"}}>
                <NoMaxWidthTooltip 
                arrow
                title={
                  <span style={{marginBottom:'-10px', fontSize:11}}>
                    <img src={tipsIcon} style={{height:"18px",width:"15px", marginBottom:"5px", paddingRight:"2px", marginLeft:"-5px"}}/>
                    E.g., "Latest 1 Week", dollar share, dollar sales, <span style={{fontStyle:"italic"}}>by Region, Retailer, Channel, Manufacturer, or Trademark</span>
                  </span>
                }
                placement="top-start"
                slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, -14],
                      },
                    },
                  ],
                },
              }}
                >
                <p><img src={tipsIcon} style={{height:"13px",width:"13px", marginBottom:"2px"}}/>
                <span style={{fontWeight:900, fontSize:11}}>Tips:</span>&nbsp;
                <span style={{fontSize:11,}}>For impactful business insights, structure your question to include: Category, Time Period, Geography and Measures</span></p>
                {/* <p style={{fontSize:11, marginTop:"2px !important"}}>E.g., "Latest 1 Week", dollar share, dollar sales, <span style={{fontStyle:"italic"}}>by Region, Retailer, Channel, Manufacturer, or Trademark</span></p> */}
                </NoMaxWidthTooltip>
              </div>
            </Item>
            <Item className={classes.autoTextfield}>
              <Autocomplete
                freeSolo
                options={options}
                value={inputValue}
                onInputChange={(event, newInputValue) => {
                  handleValueChange(newInputValue);
                }}
                // disabled={!isIdeal}
                disabled={isLoading ? isLoading : (restrictedUsers.includes(sessionStorage.getItem("emailid")?.toLowerCase()!) ? restrictedUsers.includes(sessionStorage.getItem("emailid")?.toLowerCase()!) : !isIdeal)}
                clearIcon={null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // multiline
                    // rows={1}
                    multiline={isMobile2} // Makes it multiline on mobile
                    rows={isMobile2 ? 4 : 1} // 4 rows on mobile, 1 on desktop
                    fullWidth
                    variant="outlined"
                    placeholder={placeholderMessage}
                    inputRef={autocompleteRef}
                    onKeyDown={handleOnKeyDown}
                    inputProps={{
                      ...params.inputProps,
                      component: TextareaAutosize,
                    }}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (<InputAdornment position="start">
                        <IconButton className={styles.newChatIcon}>
                          <input id="filePicker" type="file" accept=".csv,application/pdf" style={{ display: "none" }}
                            onClick={handleAttachmentClick}
                            onChange={(event: any) => {
                              handleFileChange(event)
                              event.target.value = null
                            }}
                          />
                          <label htmlFor="filePicker" >
                            <img src={FileAttach} alt="add attachment" />
                          </label>
                        </IconButton>
                      </InputAdornment>),
                      endAdornment: (
                        <InputAdornment position="end">
                          {isIdeal && !isLoading ? (
                            <>
                              <SpeechToText isDisable={!isIdeal && !isLoading} handleChange={(inputData) => handleSpeechToText(inputData)} />
                              <IconButton onClick={handleSend} disabled={isLoading}>
                                <img
                                  src={MessageSent}
                                  alt="Start New Chat"
                                  className={styles.sendIcon}
                                />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              {/* <CircularProgress
                              style={{
                                width: "20px",
                                height: "20px",
                                marginRight: "10px",
                              }}
                            /> */}
                              {/* {(!isIdeal && isLoading)?null:(setIsLoading(false),setPlaceholderMessage("Type your question..."))} */}
                              {/* {handlePlaceHolderMessage} */}
                            </>
                          )}
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        border: "1px solid #C0C0C0",
                        background: " #FBFCFE",
                        padding: "0px 8px 0px 16px",
                        fontSize: "12px",
                        minHeight: "10px"
                      },
                    }}
                  />
                )}
                ListboxProps={{
                  sx: {
                    fontSize: "0.8rem",
                    "& .MuiAutocomplete-option": {
                      fontSize: "0.8rem",
                    },
                  },
                }}
              />
            </Item>
          </Grid>
          <span className={styles.moreOptionsWeb}>{moreOptionsComponent()}</span>
        </Grid>
      </div>
      <div
        style={{
          textAlign: "center",
          fontSize: "12px",
          position: "relative",
          bottom: "15px",
        }}
      >
        {showError && <span className="errorMsg">Something went wrong please try again after sometime.<br /></span>}
        {showSuccess && <span className="successMsg">File Uploaded scuccessfully.<br /></span>}
        AI Generated Response, Please Validate For Accuracy
      </div>
    </div>}</>
  );
};

export default InputField;
